export const companyNewsRecords = [
  {
    slug: "company-smart-factory-200000sqm-operation",
    category: "company",
    title: "智能升级，产能蓄势｜江苏宏邦智能化新厂区正式启动建设",
    excerpt: "江苏宏邦变压器启动智能化新厂区建设，配置自动化生产线与数字化平台。建成后将全面提升研发与智造水平，优化品质与交付效率，筑牢全球配电市场根基。",
    date: "2026-03-15",
    views: 186,
    sourceName: "江苏宏邦变压器有限公司",
    sourceUrl: "",
    content: [
      "为响应国家新型电力系统建设发展号召，进一步提升智能制造水平、产品研发实力与规模化订单交付能力，江苏宏邦变压器有限公司智能化新厂区项目已正式启动建设。",
      "新厂区规划布局现代化生产车间、研发检测中心及配套设施，将配置自动化生产线、智能检测设备与数字化管理运营平台。项目建成后，将全面优化生产流程、提升产品品质与交付效率，持续增强企业市场供货能力与综合服务实力，为深耕全球配电设备市场、服务海内外工程项目发展筑牢坚实根基。"
    ]
  },
  {
    slug: "company-eight-high-efficiency-transformer-upgrades",
    category: "company",
    title: "聚焦能效升级｜江苏宏邦完成8款高能效低损耗变压器迭代升级",
    excerpt: "江苏宏邦完成8款变压器产品的高能效、低损耗迭代升级，多款产品损耗指标优于国家一级能效标准。",
    date: "2025-12-20",
    views: 172,
    sourceName: "江苏宏邦变压器有限公司",
    sourceUrl: "",
    content: [
      "为助力“双碳”目标落地，江苏宏邦持续深耕节能配电技术研发，2025年成功完成8款变压器产品的高能效、低损耗迭代升级。",
      "本次升级聚焦铁心优化、线圈结构改进与工艺革新，多款产品损耗指标优于国家一级能效标准，可有效降低用户用电成本，为工业、新能源及配网项目提供更高效、更环保的电力设备解决方案。"
    ]
  },
  {
    slug: "company-2024-sales-over-3-billion",
    category: "company",
    title: "扩能增效，业绩突破｜江苏宏邦 2024 年销售业绩超30亿元",
    excerpt: "2024年，江苏宏邦持续扩大生产规模，全年销售业绩突破30亿元，市场竞争力与行业影响力持续提升。",
    date: "2024-11-08",
    views: 158,
    sourceName: "江苏宏邦变压器有限公司",
    sourceUrl: "",
    content: [
      "2024年，江苏宏邦持续扩大生产规模，工厂面积提升至5.8万平方米，新建两座标准化生产车间，进一步释放产能、优化交付效率。",
      "凭借稳定的产品品质与优质的客户服务，公司全年销售业绩突破30亿元，同比实现大幅增长，市场竞争力与行业影响力持续提升。"
    ]
  },
  {
    slug: "company-full-process-quality-control-system",
    category: "company",
    title: "质量为本，标准先行｜江苏宏邦建立全流程质量管控体系",
    excerpt: "江苏宏邦建立覆盖来料检验、生产过程监控、出厂试验等全环节的严格质量管控体系。",
    date: "2023-09-15",
    views: 143,
    sourceName: "江苏宏邦变压器有限公司",
    sourceUrl: "",
    content: [
      "为筑牢产品品质防线，江苏宏邦于2023年正式建立全流程严格质量管控体系，覆盖来料检验、生产过程监控、出厂试验等全环节。",
      "公司产品顺利通过多项行业专业检测，关键性能指标均达到国家及行业标准要求，以严苛品控为客户提供可靠的电力设备保障。"
    ]
  },
  {
    slug: "company-jiangsu-hongbang-established",
    category: "company",
    title: "扬帆起航，立足实业｜江苏宏邦变压器有限公司正式成立",
    excerpt: "2022年，江苏宏邦变压器有限公司正式成立，落户江苏徐州并建成标准化现代化生产基地。",
    date: "2022-06-28",
    views: 132,
    sourceName: "江苏宏邦变压器有限公司",
    sourceUrl: "",
    content: [
      "2022年，江苏宏邦变压器有限公司正式成立，落户江苏徐州并建成标准化现代化生产基地。",
      "公司专注于输配电设备研发、制造与销售，以“品质立业、服务致远”为理念，迈出了深耕变压器行业的坚实一步。"
    ]
  }
];
